export enum Tab {
  SERVICES = "Services",
  REVIEWS = "Reviews",
  IMAGES = "Images",
  PRODUCTS = "Products",
}